/* @flow */

import React, { type Node } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { Icon, Lexs, Root as CustomRoot } from './styles';
import { compare2023Icon } from '../Icons';
import SideButton from '../SideButton';
import { Tooltip } from '../Tooltip/Tooltip';
import type { TComparisonState } from '../../types/compare';
import type { TRootState } from '../../types/rootState';
import type { TDispatch } from '../../types/core';
import type { TColorOptions } from '../SideButton/SideButton';
import { compareToggleAction } from '../../actions/compare';

const getRootNode = (root, mode) => {
	if (root) return root;
	if (mode === 'Lexs') return Lexs;
	return CustomRoot;
};

type TProps = {
	id: string,
	mode?: 'Side' | 'Lexs',
	root?: Node,
	withText?: boolean,
	dataQa?: string,
	color?: TColorOptions,
};

const CompareBtn = ({ mode, root, id, withText, dataQa, color }: TProps): Node => {
	const dispatch: TDispatch = useDispatch();
	const store = useStore();
	const compare: TComparisonState = useSelector((state: TRootState) => state.compare);

	const activeItem = compare.items.find((item) => item.apartment.id === id);
	const isActive = !!activeItem;

	const handleClick = async (ev) => {
		ev.preventDefault();
		await compareToggleAction(id, isActive)(dispatch, store.getState);
	};

	const Root = getRootNode(root, mode);

	const title = isActive ? 'Убрать из сравнения' : 'Добавить в сравнение';
	const text = isActive ? 'В сравнении' : 'Сравнить';

	if (mode === 'Side') {
		return (
			<Tooltip content={title} placement="top" touch={false}>
				<div>
					<SideButton
						data-qa={dataQa}
						id="buttonCompare"
						isActive={isActive}
						type="button"
						onClick={handleClick}
						color={color}
					>
						<Icon mode={mode} isActive={isActive} viewBox="0 0 24 24">
							{compare2023Icon}
						</Icon>
					</SideButton>
				</div>
			</Tooltip>
		);
	}

	return (
		<Root data-qa={dataQa} id="buttonCompare" isActive={isActive} type="button" title={title} onClick={handleClick}>
			<Icon viewBox="0 0 24 24">{compare2023Icon}</Icon>
			{withText && <span>{text}</span>}
		</Root>
	);
};

CompareBtn.defaultProps = {
	mode: null,
	root: null,
	withText: false,
	dataQa: null,
	color: 'default',
};

export default CompareBtn;
